import React, {useCallback, useMemo, useState, useEffect, useLayoutEffect} from "react";
import InterSectionObserver from '../../../common/components/intersection/InterSectionObserver';
import useFetch from "@common/hooks/fetch/useFetch";
import {getAdCategoryList} from "@common/services/restapi/ad";
import NewDropdown from "../component/NewDropdown";
import NewTextRadio from "../component/NewTextRadio";
import SmallCardHorizontal from "../set/SmallCardHorizontal";
import {useLocation, useParams, useHistory} from "react-router-dom";
import AdCategory from '../../../common/enums/AdCategory.enums'
import Page from '../../../common/enums/Page.enums'
import Sort from '../../../common/enums/Sort.enums'
import {convertPath} from "@common/utils/path/linkPath";

const AD_CATEGORY_MENU = [AdCategory.tv, AdCategory.print, AdCategory.radio, AdCategory.outdoor, AdCategory.cinema, AdCategory.inet,
  AdCategory.internet, AdCategory.mobile, AdCategory.newtype, AdCategory.foreign];

const SORT_LIST = [Sort.wdate, Sort.acount];

function AdHome() {
  const {category} = useParams();
  const [adCategoryList, setAdCategoryList] = useState([]);
  const [page, setPage] = useState(Page.page.defaultPage);
  const [selectedSorting, setSelectedSorting] = useState(SORT_LIST[0]);
  const [selectedStats, setSelectedStats] = useState(category);
  const [selectedStatsEnums, setSelectedStatsEnums] = useState(AdCategory.enumValueOf(category));
  const location = useLocation();

  const searchQuery = useMemo(() => {
    if (!selectedStats) return null;
    return {
      category: selectedStats,
      sortField1: selectedSorting.enumKey,
      sortOption1: selectedSorting.descSort,
      pageNumber: page,
      pageSize: Page.size.defaultSize
    }
  }, [page, selectedStats, selectedSorting]);

  const {data, loading: dataLoading} = useFetch(() => getAdCategoryList(searchQuery), [searchQuery], {});

  const handleSelectThing = useCallback((selectThing) => {
    window.scrollTo(0, 0);
    window.location.replace(`${convertPath('/ad/'+ selectThing.enumKey)}`);

    // setSelectedStats(selectThing.enumKey);
    // setPage(Page.page.defaultPage);
    // setAdCategoryList([]);
  }, []);

  const handleSelectSortThing = useCallback((selectThing) => {
    window.scrollTo(0, 0);
    setSelectedSorting(selectThing);
    setPage(Page.page.defaultPage);
    setAdCategoryList([]);
  }, []);

  useEffect(() => {
    if (data && data.adList) {
      setAdCategoryList(adCategoryList.concat(data.adList));
    }
  }, [data]);

  const handleObserver = useCallback(() => {
    setPage(page + 1);
  }, [page]);

  return (
    <>
      <div className="common-header--top">
        <h3 className="header-title">광고물 DB</h3>
      </div>

      <section className="common-body--list ad-home">
        <div className="row-box ad-home">
          <NewDropdown
            additionalClassName="stats-select-list"
            defaultValue={selectedStatsEnums}
            thingsList={AD_CATEGORY_MENU}
            onSelectThing={handleSelectThing}
          />

          <NewTextRadio
            thingsList={SORT_LIST}
            onSelectThing={handleSelectSortThing}
          />
        </div>
        <div className="ad-list ad-home" id="infinite-review-view">
          {
            adCategoryList &&
            <SmallCardHorizontal
              source={adCategoryList}
              isMine={false}
              link={`/ad/${selectedStats}/`}
            />
          }
        </div>
        <InterSectionObserver dataLoading={dataLoading} onHandleObserver={handleObserver}/>
      </section>
    </>
  )
}

export default AdHome;
